export const PROFILE_COMPLETION_PETS_CHANGED_EVENT = 'profile-completion-pets-changed';
export const PROFILE_COMPLETION_SESSION_CHANGED_EVENT = 'profile-completion-session-changed';

export function notifyProfileCompletionPetsChanged(): void {
    globalThis.dispatchEvent(new Event(PROFILE_COMPLETION_PETS_CHANGED_EVENT));
}

export function notifyProfileCompletionSessionChanged(): void {
    globalThis.dispatchEvent(new Event(PROFILE_COMPLETION_SESSION_CHANGED_EVENT));
}
